import LayoutContent from '@/layout/Content';
import Content from './Content';

const RoomPage = () => {
    return (
        <LayoutContent className="p-floor" title={`QUẢN LÝ PHÒNG`}>
            <Content />
        </LayoutContent>
    );
};

export default RoomPage;
